import React from "react";
import "../components/EnglishUnavailable.css";

const EnglishUnavailable = () => {
  return (
    <div className="english-unavailable">
      <main className="unavailable-card">
        <div className="unavailable-logo">
          twoja<span>opiekunka</span>.pl
        </div>

        <div className="unavailable-icon">🌍</div>

        <h1>English version coming soon</h1>

        <p className="unavailable-lead">
          Thank you for visiting TwojaOpiekunka.pl.
        </p>

        <p>
          Our English-language version is not available yet. We are currently
          working on making our platform accessible to international users.
        </p>

        <div className="unavailable-message">Please check back soon.</div>

        <footer>© {new Date().getFullYear()} TwojaOpiekunka.pl</footer>
      </main>
    </div>
  );
};

export default EnglishUnavailable;
